import React from 'react'

const Data_Policy = () => {
  return (
    <div className='bg-white'>
      <div className="mt-5 ml-5 w-[95%] md:w-[90%] md:mx-auto md:px-20 px-4">
        {/* Data Protection Policy */}
        <h1 className="text-[10px] md:text-[24px] font-semibold mt-5 md:pt-10 pt-5">
          DATA POLICY
        </h1>
        <p className="inline text-[10px] md:text-[17px] font-bold  text-[#979797] break-words whitespace-normal italic">
          Last updated on 22nd March 2025
        </p>
  
        <div className='md:h-5 h-2'></div>
  
        <div className="mt-10 text-[10px] md:text-[32px] text-black leading-relaxed font-normal space-y-6">
          <p>
            This Data Policy explains how we collect, use, share, and protect your personal information when you use our website, mobile application, or services (collectively, the “Platform”).
          </p>
  
          <div className='-space-y-2'>
            <p><span className="font-bold text-[10px] md:text-[32px]">1. What Data We Collect</span></p>
            <p className="font-bold text-[10px] md:text-[32px]">a) Personal Information</p>
            <ul className="list-disc ml-6 md:ml-8 -space-y-2">
              <li className="text-[10px] md:text-[32px]">Name</li>
              <li className="text-[10px] md:text-[32px]">Email address</li>
              <li className="text-[10px] md:text-[32px]">Phone number</li>
              <li className="text-[10px] md:text-[32px]">Location (farm location or residence)</li>
              <li className="text-[10px] md:text-[32px]">Profile information</li>
              <li className="text-[10px] md:text-[32px]">Government ID (if needed for verification)</li>
            </ul>
          </div>
  
          <div className='-space-y-2'>
            <p className="font-bold text-[10px] md:text-[32px]">b) Farm-Related Information</p>
            <ul className="list-disc ml-6 md:ml-8 -space-y-2">
              <li className="text-[10px] md:text-[32px]">Farm size and type</li>
              <li className="text-[10px] md:text-[32px]">Crops/livestock information</li>
              <li className="text-[10px] md:text-[32px]">Farming practices</li>
              <li className="text-[10px] md:text-[32px]">Market activity (buy/sell history)</li>
            </ul>
          </div>
  
          <div>
            <p className="font-bold text-[10px] md:text-[32px]">c) Usage Data</p>
            <ul className="list-disc ml-6 md:ml-8 -space-y-2">
              <li className="text-[10px] md:text-[32px]">Device type and browser</li>
              <li className="text-[10px] md:text-[32px]">IP address</li>
              <li className="text-[10px] md:text-[32px]">Log-in times and interaction data</li>
              <li className="text-[10px] md:text-[32px]">Cookies and analytics information</li>
            </ul>
          </div>
  
          <div>
            <p><span className="font-bold text-[10px] md:text-[32px]">2. How We Use Your Data</span></p>
            <ul className="list-disc ml-6 md:ml-8 -space-y-2">
              <li className="text-[10px] md:text-[32px]">Provide access to the platform and its services</li>
              <li className="text-[10px] md:text-[32px]">Connect farmers, buyers, and suppliers</li>
              <li className="text-[10px] md:text-[32px]">Improve and customize your user experience</li>
              <li className="text-[10px] md:text-[32px]">Send relevant updates, offers, or notifications</li>
              <li className="text-[10px] md:text-[32px]">Facilitate transactions and support services</li>
              <li className="text-[10px] md:text-[32px]">Conduct research and development for agricultural advancement</li>
            </ul>
          </div>
  
          <div>
            <p><span className="font-bold text-[10px] md:text-[32px]">3. Sharing Your Data</span></p>
            <ul className="list-disc ml-6 md:ml-8 -space-y-2">
              <li className="text-[10px] md:text-[32px]">With your consent (e.g., when connecting you with other farmers or businesses)</li>
              <li className="text-[10px] md:text-[32px]">With third-party service providers who help us operate the platform (e.g., analytics, hosting)</li>
              <li className="text-[10px] md:text-[32px]">If required by law, legal process, or government requests</li>
              <li className="text-[10px] md:text-[32px]">In case of a merger, acquisition, or sale of assets</li>
            </ul>
          </div>
  
          <div className='-space-y-2'>
            <p><span className="font-bold text-[10px] md:text-[32px]">4. Data Security</span></p>
            <p className="text-[10px] md:text-[32px]">
              We take reasonable technical and organizational measures to protect your data from unauthorized access, disclosure, or misuse. This includes encryption, secure servers, and regular security audits.
            </p>
          </div>
  
          <div className='-space-y-2'>
            <p><span className="font-bold text-[10px] md:text-[32px]">5. Your Rights</span></p>
            <p className="text-[10px] md:text-[32px]">
              Depending on your location and applicable laws, you may have the right to:
            </p>
            <ul className="list-disc ml-6 md:ml-8 -space-y-2">
              <li className="text-[10px] md:text-[32px]">Access the personal data we hold about you</li>
              <li className="text-[10px] md:text-[32px]">Request correction or deletion of your data</li>
              <li className="text-[10px] md:text-[32px]">Object to or restrict certain types of data processing</li>
              <li className="text-[10px] md:text-[32px]">Withdraw consent at any time</li>
            </ul>
            <p className="text-[10px] md:text-[32px]">
              To make a request, contact us at: support@farmnet.com
            </p>
          </div>
  
          <div className='-space-y-2'>
            <p><span className="font-bold text-[10px] md:text-[32px]">6. Data Retention</span></p>
            <p className="text-[10px] md:text-[32px]">
              We retain your data only for as long as necessary to fulfill the purposes described in this policy, or as required by law.
            </p>
          </div>
  
          <div className='-space-y-2'>
            <p><span className="font-bold text-[10px] md:text-[32px]">7. Cookies and Tracking Technologies</span></p>
            <p className="text-[10px] md:text-[32px]">
              We use cookies and similar technologies to enhance your experience, analyze usage, and deliver personalized content. You can manage cookie preferences through your browser settings.
            </p>
          </div>
  
          <div className='-space-y-2'>
            <p><span className="font-bold text-[10px] md:text-[32px]">8. Children’s Privacy</span></p>
            <p className="text-[10px] md:text-[32px]">
              Our platform is not intended for children under 13 (or the relevant minimum age in your jurisdiction). We do not knowingly collect personal information from children.
            </p>
          </div>
  
          <div className='-space-y-2'>
            <p><span className="font-bold text-[10px] md:text-[32px]">9. International Users</span></p>
            <p className="text-[10px] md:text-[32px]">
              If you are accessing the Platform from outside [Insert Country], your information may be transferred to and processed in [Insert Country], where data protection laws may differ.
            </p>
          </div>
  
          <div className='-space-y-2'> 
            <p><span className="font-bold text-[10px] md:text-[32px]">10. Changes to This Policy</span></p>
            <p className="text-[10px] md:text-[32px]">
              We may update this policy from time to time. We will notify you of significant changes via email or a notice on the platform.
            </p>
          </div>
  
          <div className='-space-y-2'>
            <p><span className="font-bold text-[10px] md:text-[32px]">11. Contact Us</span></p>
            <p className="text-[10px] md:text-[32px]">
              If you have questions or concerns about this Data Policy or your personal information, contact us at:
            </p>
              
          <div className="">
            Email: <a href="mailto:support@farmnet.com">support@farmnet.com</a>
          </div>
  
          </div>

          <div className='md:h-8 h-2'></div>
        </div>
      </div>
    </div>
  )
}

export default Data_Policy
